/**
 * @file error-popup.ts
 * @module app/modules/_common/components/pop-up/error-popup
 * @description Utility for displaying an error popup.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 2.1.1
 * @version 2.1.2
 */

import { showPopup } from './popup-service';
import type { PopupOptions } from './popup-service';

const showErrorPopup = (options: PopupOptions | string = {}) =>
  showPopup('error', options);

export default showErrorPopup;